import deepSet from 'lodash/set';
import { bigQuery } from '@fiverr-private/obs';
import { BigQueryEventName, BigQueryEventProperties, BigQuertyEventsContext } from './bigQuery.types';
import { BIGQUERY_PROPERTIES_MAP, BIGQUERY_EMBEDDED_PROPERTIES } from './bigQuery.constants';

const mapProps = (props: Partial<BigQueryEventProperties>) => {
    const result = {};
    Object.entries(props).forEach(([key, value]) => {
        const path = BIGQUERY_PROPERTIES_MAP[key] || key;
        deepSet(result, path, value);
    });
    return result;
};

const createBigQueryReporter = () => {
    let context: BigQuertyEventsContext;

    const enrichContext = (
        newContext: BigQuertyEventsContext | ((currentContext: BigQuertyEventsContext) => BigQuertyEventsContext)
    ) => {
        context = { ...context, ...(typeof newContext === 'function' ? newContext(context) : newContext) };
    };

    const send = (type: BigQueryEventName) => {
        bigQuery.send({
            type,
            ...mapProps({ ...BIGQUERY_EMBEDDED_PROPERTIES[type], ...context }),
        });
    };

    return {
        enrichContext,
        send,
    };
};

export const globalBigQueryReporter = createBigQueryReporter();
